import * as React from 'react';

const BagIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path d="M9.846 28.001v-1.423c-.5 0-.933-.18-1.298-.542A1.769 1.769 0 0 1 8 24.732V11.181c0-.495.184-.926.552-1.294.368-.368.8-.552 1.294-.552h3.449V6.014c0-.243.09-.46.273-.65a.883.883 0 0 1 .663-.286h3.538c.26 0 .485.095.676.286.19.19.286.407.286.65v3.32h3.423c.494 0 .926.185 1.294.553.368.368.552.8.552 1.294v13.551c0 .508-.184.942-.552 1.304-.368.361-.8.542-1.294.542v1.423h-1.026v-1.423H10.872v1.423H9.846ZM14.32 9.335h3.385V6.104h-3.384v3.23Zm1.68 7.09c1.218 0 2.422-.145 3.61-.434a11.903 11.903 0 0 0 3.364-1.39v-3.42a.799.799 0 0 0-.23-.59.798.798 0 0 0-.59-.23H9.846a.798.798 0 0 0-.59.23.799.799 0 0 0-.23.59v3.42c1.054.638 2.176 1.101 3.364 1.39 1.188.289 2.392.433 3.61.433Zm-.513 2.448v-1.341c-1.15-.05-2.267-.22-3.351-.512a12.677 12.677 0 0 1-3.11-1.303v9.015c0 .24.077.436.23.59.154.154.35.23.59.23h12.308c.24 0 .436-.076.59-.23a.799.799 0 0 0 .23-.59v-9.015a12.678 12.678 0 0 1-3.11 1.303c-1.084.292-2.2.462-3.351.512v1.341h-1.026Z" />
    </g>
  </svg>
);

export default BagIcon;
